export default "__VITE_ASSET__Bv7Hw8$k__"